// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/reasonReact.js");

function loginButton(clientId, redirectUri) {
  return React.createElement("a", {
              className: "f6 dib white bg-animate hover-bg-white hover-black no-underline pv2 ph4 br-pill ba b--white-20",
              href: "https://github.com/login/oauth/authorize?scope=notifications&client_id=" + (clientId + ("&redirect_uri=" + redirectUri))
            }, "Log In");
}

function logoutButton(onLogout) {
  return React.createElement("a", {
              className: "f6 dib white bg-animate hover-bg-white hover-black no-underline pv2 ph4 br-pill ba b--white-20",
              onClick: onLogout
            }, "Log Out");
}

var component = ReasonReact.statelessComponent("Header");

function make(loggedIn, onLogout, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var btn = loggedIn !== 0 ? logoutButton(onLogout) : loginButton("27778e7d924f0023ca79", "https://ianjsikes.github.io/github-notification-viewer");
      return React.createElement("nav", {
                  className: "flex justify-between bb b--white-10",
                  style: {
                    backgroundColor: "#000000"
                  }
                }, React.createElement("div", {
                      className: "flex-grow pa3 flex items-center"
                    }, btn));
    });
  return newrecord;
}

exports.loginButton  = loginButton;
exports.logoutButton = logoutButton;
exports.component    = component;
exports.make         = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/header.re
// module id = 100
// module chunks = 0